import React, { useCallback, useEffect, useState } from "react";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import { getDailyReport } from "../../../store/DashboardSlice";
import Table from "./components/Table";
import ToolBar from "../../../components/ToolBar";
import { Button, Col, Form, Row, Spin } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import { FormBox, InputBox } from "../../../components/AntdAddons";
import { CONSTANT } from "../../../config/Constant";
import { getProviderListByCodes } from "../../../store/ProviderSlice";

const Dashboard = () => {
  const dispatch: AppDispatch = useDispatch();
  const [tableData, setTableData] = useState<[]>([]);
  const [reportType, setReportType] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [providerListByCodes, setProviderListByCodes] = useState<any>();
  const [form] = Form.useForm();

  const disabledDate: RangePickerProps["disabledDate"] = (current) => {
    return current && current > dayjs().subtract(1, "day");
  };
  const yesterdayDate = dayjs().subtract(1, "day");

  const getReport = useCallback(
    (date, providerCode?: string) => {
      const payload = {
        date: dayjs(date).format(CONSTANT.POST_DATE_FORMAT),
        provider_code: providerCode,
      };
      setLoading(true);
      dispatch(getDailyReport(payload))
        .then((res: any) => {
          if (res?.data) {
            setReportType(res.data.provider_code);
            if (res?.data?.daily_report) {
              setTableData(res?.data?.daily_report);
            }
          }
        })
        .catch((e: any) => {
          setTableData([]);
          console.warn(e);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [dispatch]
  );

  const getProvidersByCodes = async () => {
    dispatch(getProviderListByCodes())
      .then((res: any) => {
        const listOfProvidersByCodes = res?.data
          .filter((item) => item?.id)
          .reduce((acc, current) => {
            const x = acc.find((item) => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);
        listOfProvidersByCodes &&
          setProviderListByCodes(listOfProvidersByCodes);
      })
      .catch((error: any) => {
        setProviderListByCodes([]);
      });
  };

  useEffect(() => {
    getProvidersByCodes();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const yesterdayDate = dayjs().subtract(1, "day");
    getReport(yesterdayDate);
  }, [getReport]);

  const handleSubmit = (data: any) => {
    getReport(data?.date, data.provider_code.toLowerCase());
  };

  return (
    <>
      <ToolBar
        title={"Dashboard"}
        children={
          <>
            <FormBox
              id="dateFilter"
              form={form}
              onFinish={handleSubmit}
              initialValues={{ date: yesterdayDate }}
              className="filterForm"
            >
              <Row gutter={20} align={"middle"}>
                <Col span={9}>
                  <InputBox.DatePicker
                    name={"date"}
                    placeholder={"Select Date"}
                    disabledDate={disabledDate}
                    format={CONSTANT.POST_DATE_FORMAT}
                    allowClear={false}
                    noStyle
                  />
                </Col>
                <Col span={7}>
                  <InputBox.Select
                    name={"provider_code"}
                    // noStyle
                    defaultValue={"PP"}
                    placeholder="Select To Provider"
                    options={{
                      list:
                        providerListByCodes?.length > 0
                          ? providerListByCodes
                          : [],
                      valueKey: "id",
                      textKey: "provider_code",
                    }}
                    notFoundContent={
                      providerListByCodes?.length > 0 ? null : <Spin />
                    }
                    style={{ margin: 0 }}
                    // rules={[validations.required.text('Provider')]}
                  />
                </Col>

                {/* <Col span={6}>
                <FormBox
                  id="providerCodeFilter"
                  form={form}
                  onFinish={handleSubmit}
                  initialValues={{ provider_code: 'pp' }}
                >
                  <InputBox.Select
                    name={"provider_code"}
                    allowClear
                    showSearch
                    placeholder="Select To Provider"
                    options={{
                      list: CONSTANT.PROVIDER_CODE,
                      valueKey: "provider_code",
                      textKey: "id",
                    }}
                    // rules={[validations.required.text('Provider')]}
                  />
                </FormBox>
              </Col> */}
                <Col span={8}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    form="dateFilter"
                    loading={loading}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </FormBox>
          </>
        }
      />
      <Table tableData={tableData} loading={loading} reportType={reportType} />
    </>
  );
};

export default Dashboard;
